export default __webpack_public_path__ + "static/media/uk.b9a2ba74.png";